module.exports = __webpack_public_path__ + "static/images/containers/Landing/images/page_marker_active.0fc3875b.png";


//////////////////
// WEBPACK FOOTER
// ./containers/Landing/images/page_marker_active.png
// module id = 3171
// module chunks = 11